import { useEffect, useState } from "react"
import { modifyHref } from "@/components/Shared/HeaderNavTabs/utils"

const SiteMap = ({ data = {} }) => {
  const [isHeaderActive, setIsHeaderActive] = useState(true)
  const { siteMapHeading = "", options = [], appliedCssClassNames = "" } = data

  const isMobile = typeof window !== "undefined" && window.innerWidth < 1025

  useEffect(() => {
    if (isMobile) {
      setIsHeaderActive(false)
    }
  }, [isMobile])

  const handleHeaderClick = () => {
    setIsHeaderActive(isMobile ? !isHeaderActive : true)
  }

  return (
    <div
      className={`list ${
        appliedCssClassNames?.trim() === "sitemap-first-list"
          ? "sitemap-first-list"
          : ""
      }`}
    >
      <div className="list-inner">
        <h3
          className={`cmp-list__heading ${isHeaderActive ? "active" : ""}`}
          onClick={handleHeaderClick}
        >
          {siteMapHeading}
        </h3>

        {options?.map((item, i) => (
          <ul
            key={`${item?.subHeader}-${i}`}
            className={`cmp-list ${isHeaderActive ? "show" : "hide"}`}
          >
            <li className="cmp-list__subhead">{item?.subHeader}</li>
            {item?.subHeaderItem?.map((subItem, j) => (
              <ul
                className="cmp-page-name"
                key={`${subItem?.subDisplayName}-${j}`}
              >
                <li>
                  <a
                    target={`${subItem?.isNewTab ? "_blank" : "_self"}`}
                    href={modifyHref(subItem?.subPageLink)}
                  >
                    {subItem?.subDisplayName}
                  </a>
                </li>
              </ul>
            ))}
          </ul>
        ))}
      </div>
    </div>
  )
}

export default SiteMap
